//@ts-ignore
//@ts-nocheck
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "../utilities/hooks/scrollToTop";
import Guests from "../views/Guests/Guests";
import PaymentConfirmation from "../views/Payment-Confirmation/Payment-Confirmation";
import Payment from "../views/Payment/Payment";
import RegisterSoloSponsored from "../views/Register-solo-Sponsored/Register-solo-Sponsored";
import RegisterSolo from "../views/Register-solo/Register-solo";
import RegisterSponsored from "../views/Register-Sponsored/Register-Sponsored";
import Register from "../views/Register/Register";
import Welcome from "../views/Welcome/Welcome";

function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" index element={<Welcome />} />
        {/*  
        <Route element={<AppLayout />}>
       <Route path="/" index element={<Home />} /> 
                  <Route path="/home" element={<Home />} />
<Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/contactUs" element={<ContactUs />} />
         
          <Route path="/aboutTournament" element={<AboutTournament />} />
        
        </Route>
            */}
        <Route path="/register" index element={<Register />} />
        <Route path="/register-solo" element={<RegisterSolo />} />
        <Route path="/register-sponsored" element={<RegisterSponsored />} />
        <Route path="/register-solo-sponsored" element={<RegisterSoloSponsored />} />
        <Route path="/guests" element={<Guests />} />
        <Route path="/payment" element={<Payment />} />
        {/*  <Route path="/paymentTWO" element={<PaymentTWO />} /> */}
        <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
        <Route path="*" element={<h1>ERROR 404 NO ENCONTRADO</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
